import {
  BERTHTARIFF,
  ADMIN,
  YACHT,
  APPROVAL,
  PARKING_LAYOUT,
  CASHCHEQUEPAYMENT,
  ADDITIONAL_SERVICE,
  COMPLETE,
} from "./constants";
import { http } from "./httpServices";

export function getBerthTariffList() {
  return http.get(`${BERTHTARIFF}${ADMIN}`);
}

export function getYachtRegistrationList() {
  return http.get(`${YACHT}?status=processing`);
}

export function getYachtRegistrationHistory(page: number, limit: number) {
  return http.get(`${YACHT}?page=${page}&limit=${limit}`);
}
export function postTariffDetails(data: any) {
  return http.post(BERTHTARIFF, data);
}

export function getTariffDataFromId(id: string | any) {
  return http.get(`${BERTHTARIFF}/${id}`);
}

export function updateTariffDetails(data: any, id: string | any) {
  return http.put(`${BERTHTARIFF}/${id}`, data);
}

export function getYatchRegistrationDetails(id: string | undefined) {
  return http.get(`${YACHT}/${id}`);
}

export function putCashChequePayment(id: string | any, data: any) {
  return http.put(`${YACHT}/${CASHCHEQUEPAYMENT}/${id}`, data);
}

export function putYachtApproveRejectData(data: any, id: string | any) {
  return http.put(`${YACHT}${APPROVAL}/${id}`, data);
}

export function getParkingLayout() {
  return http.get(`${YACHT}/${PARKING_LAYOUT}`);
}

export function getYachtAdditionalServiceList() {
  return http.get(`${ADDITIONAL_SERVICE}${ADMIN}?status=processing`);
}

export function getYachtAdditionalServiceHistoryList(page: number, limit: number) {
  return http.get(`${ADDITIONAL_SERVICE}${ADMIN}?page=${page}&limit=${limit}`);
}

export function getYachtAdditionalServiceDetailsById(id: string | any) {
  return http.get(`${ADDITIONAL_SERVICE}/${id}`);
}

export function yachtAddServiceComplete(id: string | any) {
  return http.get(`${ADDITIONAL_SERVICE}${COMPLETE}/${id}`);
}
